import React, { useCallback, useEffect, useState } from 'react'
import Screen from './Screen'
import { Checkbox, FormControlLabel, Button, Typography } from '@material-ui/core'
import { useRouter } from 'react-router5'

export const shouldRandomizeQuestions = () => (
  localStorage.getItem('randomizeQuestions') !== 'false'
)

export const shouldEnableTimer = () => (
  localStorage.getItem('enableTimer') !== 'false'
)

export const shouldDisplayQuestionId = () => (
  localStorage.getItem('displayQuestionId') !== 'false'
)

export default function Settings() {
  const [dirty, setDirty] = useState(false)
  const router = useRouter()
  const changeSetting = useCallback((key, value) => {
    localStorage.setItem(key, value)
    setDirty(x => !x)
  }, [setDirty])

  return (
    <Screen>
      <Typography variant="h2">Settings</Typography>

      <div style={{ marginBottom: '1rem' }} />
      <div style={{ display: 'flex', flexDirection: 'column', flexGrow: 1 }}>

        <FormControlLabel
          control={
            <Checkbox
              checked={shouldRandomizeQuestions()}
              onChange={e => { changeSetting('randomizeQuestions', e.target.checked) }}
            />}
          label="Randomize questions"
        />

        <FormControlLabel
          control={<Checkbox
            checked={shouldEnableTimer()}
            onChange={e => { changeSetting('enableTimer', e.target.checked) }}
          />}
          label="Enable timer"
        />

        <FormControlLabel
          control={<Checkbox
            checked={shouldDisplayQuestionId()}
            onChange={e => { changeSetting('displayQuestionId', e.target.checked) }}
          />}
          label="Display question ID"
        />

        <div style={{ flexGrow: 1 }} />
        <Button
          onClick={() => router.navigate('home')}>Back</Button>
      </div>
    </Screen>
  )
}